import { EVENTS } from '../consts'
import errorFromHttpResponse from '../utils/error-from-http-response.js'
import AnalyticsService from './AnalyticsService'
import NetworkService from './NetworkService'
import i18n from '@/i18n'

export default {
  loading: false,

  endSession(context, sessionId) {
    return NetworkService.endSession({ sessionId }).then(() => {
      const currentSessionData = context.$store.state.user.session

      AnalyticsService.captureEvent(EVENTS.SESSION_ENDED, {
        event: EVENTS.SESSION_ENDED,
        sessionId: sessionId,
        subject: currentSessionData.subTopic,
      })
    })
  },

  newSession(context, sessionType, sessionSubTopic, options) {
    const onRetry = options && options.onRetry
    const data = {
      sessionType,
      sessionSubTopic,
    }

    return NetworkService.newSession(data, onRetry).then(res => {
      const data = res.data || {}
      const { sessionId } = data

      // const currentSession = {
      //   sessionId,
      //   data: context.$store.state.user.session
      // };

      if (sessionId) {
        const sessionData = {
          type: sessionType,
          subTopic: sessionSubTopic,
          _id: sessionId,
        }
        context.$store.dispatch('user/updateSession', sessionData)
        context.$router.replace(context.$store.getters['user/sessionPath'])
      } else {
        context.$router.replace(`/${i18n.locale}/dashboard`)
      }
      // analytics: track when a session has started
      // AnalyticsService.trackSessionStarted(
      //   context,
      //   currentSession,
      //   sessionType,
      //   sessionSubTopic,
      //   context.$store.state.user.isFakeUser
      // );

      return sessionId
    })
  },

  useExistingSession(context, sessionId, options) {
    const onRetry = options && options.onRetry

    return NetworkService.checkSession({ sessionId }, onRetry)
      .then(res => {
        const data = res.data || {}
        const { sessionId } = data

        return sessionId
      })
      .catch(res => {
        if (res.status === 404) {
          context.$router.replace(`/${i18n.locale}/dashboard`)
        } else {
          throw res
        }
      })
  },

  getCurrentSession() {
    return NetworkService.currentSession()
      .then(res => {
        if (!res.data || !res.data.sessionId) {
          return Promise.resolve({ sessionData: {} })
        }

        const { sessionId, data } = res.data
        const { type, subTopic } = data

        if (type && subTopic && sessionId) {
          return Promise.resolve({ sessionData: data })
        }
      })
      .catch(resp => {
        throw errorFromHttpResponse(resp)
      })
  },

  getRecapSessionForDms(sessionId) {
    return NetworkService.getRecapSessionForDms({
      sessionId,
    })
      .then(resp => {
        const { sessionId, data } = resp.data || {}
        const { type, subTopic } = data

        if (type && subTopic && sessionId) {
          return Promise.resolve({ sessionData: data })
        }
      })
      .catch(resp => {
        throw errorFromHttpResponse(resp)
      })
  },

  getLatestSession() {
    return NetworkService.latestSession()
      .then(res => {
        const { data } = res.data || {}
        return Promise.resolve({ sessionData: data })
      })
      .catch(resp => {
        throw errorFromHttpResponse(resp)
      })
  },
}
